"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var base_1 = require("@bhtp-client-api/base");
var BhtpEditService = (function (_super) {
    __extends(BhtpEditService, _super);
    function BhtpEditService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        return _this;
    }
    BhtpEditService.prototype.getForEdit = function (policyNumber) {
        var url = this.getFullUrl("/v2/Policy/Edit/" + policyNumber);
        var options = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        return this.http.get(url, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    BhtpEditService.prototype.validateEditPolicy = function (editRequest) {
        var url = this.getFullUrl("v1/Policy/EditCheck");
        var body = JSON.stringify(editRequest);
        var options = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        return this.http.post(url, body, options)
            .map(function (res) {
            // response container's response type does not matter with this check.
            // we just need to return any messages that were returned from the edit check.
            var responseContainer = res.json();
            return responseContainer && responseContainer.messages ? responseContainer.messages : [];
        }).catch(this.handleError);
    };
    BhtpEditService.prototype.validateEditPolicyFullResponse = function (editRequest) {
        var url = this.getFullUrl("v1/Policy/EditCheck");
        var body = JSON.stringify(editRequest);
        var options = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        return this.http.post(url, body, options)
            .map(function (res) {
            var responseContainer = res.json();
            return responseContainer;
        }).catch(this.handleError);
    };
    BhtpEditService.prototype.purchaseEditPolicyWithValidation = function (editRequest) {
        var url = this.getFullUrl("v1/Policy/EditConfirm");
        var body = JSON.stringify(editRequest);
        var options = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        return this.http.post(url, body, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    BhtpEditService.prototype.getPolicyExistanceStatus = function (policyNumber) {
        var url = this.getFullUrl("v1/Policy/Exists/" + policyNumber);
        var options = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        return this.http.get(url, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    return BhtpEditService;
}(base_1.BhtpBaseService));
BhtpEditService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], BhtpEditService);
exports.BhtpEditService = BhtpEditService;
//# sourceMappingURL=D:/a/1/s/edit/src/edit.service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/edit/src/edit.service.js